import React from "react";

function Plot_D3js() {
  return (
    <div>
      <h1>Plot_D3js Component</h1>
      <p>This is the Plot D3js tutorial page content.</p>
    </div>
  );
}

export default Plot_D3js;
